(function() {

    window.prObj = (function() {

        function prObj() {}
        prObj.loadjQuery = function(afterLoad) {
            return prObj.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js", function() {
                prObj.$ = jQuery.noConflict();
                //document.addEventListener("DOMContentLoaded",init, false);
                if (prObj.$("#wk_add_image_for_review").length) {
                    document.getElementById("files").addEventListener("click", init, false);
                    var AttachmentArray = [];

                    var arrCounter = 0;
                    var filesCounterAlertStatus = false;
                    //init();
                    var ul = document.createElement("ul");
                    ul.className = "thumb-Images";
                    ul.id = "imgList";

                    function init() {
                        document
                            .querySelector("#files")
                            .addEventListener("change", handleFileSelect, false);
                    }
                    //handleFileSelect();
                    function handleFileSelect(e) {
                        if (!e.target.files) return;

                        var files = e.target.files;

                        for (var i = 0, f;
                            (f = files[i]); i++) {
                            var fileReader = new FileReader();

                            fileReader.onload = (function(readerEvt) {
                                return function(e) {
                                    ApplyFileValidationRules(readerEvt);
                                    RenderThumbnail(e, readerEvt);
                                    FillAttachmentArray(e, readerEvt);
                                };
                            })(f);

                            fileReader.readAsDataURL(f);
                        }
                        document
                            .getElementById("files")
                            .addEventListener("change", handleFileSelect, false);
                    }
                    prObj.$(function($) {
                        $("div").on("click", ".img-wrap .close", function() {
                            var id = $(this)
                                .closest(".img-wrap")
                                .find("img")
                                .data("id");

                            var elementPos = AttachmentArray.map(function(x) {
                                return x.FileName;
                            }).indexOf(id);
                            if (elementPos !== -1) {
                                AttachmentArray.splice(elementPos, 1);
                            }

                            $(this)
                                .parent()
                                .find("img")
                                .not()
                                .remove();

                            $(this)
                                .parent()
                                .find("div")
                                .not()
                                .remove();

                            $(this)
                                .parent()
                                .parent()
                                .find("div")
                                .not()
                                .remove();

                            var lis = document.querySelectorAll("#imgList li");
                            for (var i = 0;
                                (li = lis[i]); i++) {
                                if (li.innerHTML == "") {
                                    li.parentNode.removeChild(li);
                                }
                            }
                        });
                    });

                    function ApplyFileValidationRules(readerEvt) {
                        //To check file type according to upload conditions
                        if (CheckFileType(readerEvt.type) == false) {
                            form.find('.mp-err').html("このファイル " + readerEvt.name + " はアップロード条件に一致しません。アップロードできるのはjpg/png/gifファイルのみです。")
                            e.preventDefault();
                            return;
                        }

                        //To check file Size according to upload conditions
                        if (CheckFileSize(readerEvt.size) == false) {
                            form.find('.mp-err').html("この写真 " + readerEvt.name + " アップロード条件に一致しません。アップロードする写真の最大サイズは5MBを超えないようにしてください。")
                            e.preventDefault();
                            return;
                        }

                        //To check files count according to upload conditions
                        if (CheckFilesCount(AttachmentArray) == false) {
                            if (!filesCounterAlertStatus) {
                                filesCounterAlertStatus = true;
                                form.find('.mp-err').html("写真を5枚以上追加しました。アップロード条件により、最大5枚までの写真をアップロードできます。");
                            }
                            e.preventDefault();
                            return;
                        }
                    }

                    function CheckFileType(fileType) {
                        if (fileType == "image/jpeg") {
                            return true;
                        } else if (fileType == "image/png") {
                            return true;
                        } else if (fileType == "image/gif") {
                            return true;
                        } else {
                            return false;
                        }
                        return true;
                    }

                    function CheckFileSize(fileSize) {
                        if (fileSize < 5242880) {
                            return true;
                        } else {
                            return false;
                        }
                        return true;
                    }

                    function CheckFilesCount(AttachmentArray) {
                        //Since AttachmentArray.length return the next available index in the array,
                        //I have used the loop to get the real length
                        var len = 0;
                        for (var i = 0; i < AttachmentArray.length; i++) {
                            if (AttachmentArray[i] !== undefined) {
                                len++;
                            }
                        }
                        //To check the length does not exceed 10 files maximum
                        if (len > 4) {
                            return false;
                        } else {
                            return true;
                        }
                    }

                    function RenderThumbnail(e, readerEvt) {
                        var li = document.createElement("li");
                        ul.appendChild(li);
                        li.innerHTML = [
                            '<div class="img-wrap"> <span class="close">&times;</span>' +
                            '<img class="thumb" src="',
                            e.target.result,
                            '" title="',
                            escape(readerEvt.name),
                            '" data-id="',
                            readerEvt.name,
                            '"/>' + "</div>"
                        ].join("");

                        var div = document.createElement("div");
                        div.className = "FileNameCaptionStyle";
                        li.appendChild(div);
                        div.innerHTML = [readerEvt.name].join("");
                        document.getElementById("wk_Filelist").insertBefore(ul, null);
                    }

                    function FillAttachmentArray(e, readerEvt) {
                        AttachmentArray[arrCounter] = {
                            AttachmentType: 1,
                            ObjectType: 1,
                            FileName: readerEvt.name,
                            FileDescription: "Attachment",
                            NoteText: "",
                            MimeType: readerEvt.type,
                            Content: e.target.result.split("base64,")[1],
                            FileSizeInBytes: readerEvt.size
                        };
                        arrCounter = arrCounter + 1;
                    }


                }
                // prObj.loadCss("//netdna.bootstrapcdn.com/bootstrap/3.1.1/css/bootstrap.min.css");
                // if (document.getElementsByClassName('fa').length == 0)
                prObj.loadCss("https://netdna.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css");
                prObj.loadCss(prObj.api_url + "css/editor.css");
                prObj.loadCss("https://fonts.googleapis.com/css?family=Raleway:400,500,600");
                prObj.loadCss("https://fonts.googleapis.com/css?family=Cabin:400,500,600");
                prObj.loadCss(prObj.api_url + "css/wk_askme.css");
				prObj.loadCss(prObj.api_url + "lib/rateyo/jquery.rateyo.min.css");
                prObj.loadScript(prObj.api_url + "lib/rateyo/jquery.rateyo.min.js", function(){
                    prObj.loadScript(prObj.api_url + 'js/editor.large.js', function() {
                        return afterLoad();
                    });
                });

            });

        };
        prObj.checkLabels = function(callback) {

            return callback;
        }
		prObj.slideInterval = false;
        prObj.loadScript = function(url, callback) {
            var script = document.createElement("script");
            script.type = "text/javascript";

            if (script.readyState) {
                script.onreadystatechange = function() {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        return callback();
                    }
                };
            } else {
                script.onload = function() {
                    return callback();
                };
            }
            script.src = url;
            return document.getElementsByTagName("head")[0].appendChild(script);
        };
        prObj.showLoader = function() {
            prObj.$(".mp-loader").css("display", "block");
            // setTimeout(prObj.removeLoader(), 5000);
        };
        prObj.removeLoader = function() {
            prObj.$(".mp-loader").css("display", "none");
        };
		prObj.appendDiv = function(limit, page, sort_by = 'date_add', sort_order = 'desc', is_verified = false, append_more = false){
			var main_id_product = prObj.$("#wk-main-prod-id").val();
			var product_handle = prObj.product_handle;
			if(main_id_product == '' || typeof main_id_product == 'undefined' || prObj.$(".wk-product-reviews").length > 0)
			{
				main_id_product = prObj.product_handle;
			}
			prObj.$.ajax({
				url: prObj.api_url + 'index.php?p=ajax_product_review',
				async: true,
				cache: false,
				jsonpCallback: 'getfeedback',
				contentType: 'application/json',
				dataType: 'jsonp',
				data: {
					name: name,
					shop: prObj.shop_name,
					main_id_product: main_id_product,
					product_handle: product_handle,
					limit: limit,
					page: page,
					sort_by: sort_by,
					sort_order: sort_order,
					is_verified: is_verified
				},
				beforeSend: function() {
					// prObj.showLoader();
				},
				success: function(data) {
					let no_review_status = 'none';
					if (data == 'denied'){
						if(append_more == 1){
							prObj.$('.wk_all_reviews').append('<p >'+review_ends_here+'</p>')
						}else{
							no_review_status = 'block';
						}
					}
					else{
						data.forEach(function(items, index){
							if(index <limit)
							{
								html ='';
								html += '<div class="wk_review_card seller-product-review" data-id="'+items.id+'">';
								html += '<div class="wk_rev_hdr">';
								// html += '<p class="wk_rev_stars">'+prObj.getStars(items.review_star)+'</p>';
								html += '<div class="wk_rev_stars"><div class="rateit" id="wk_review_card_'+items.id+'"></div></div>';
								html += '<div class="mp-full-width">';

                                genderSign = '';
								if(items.cust_gender == "Male")
								{
									genderSign = '<img class="wk-gender-sign" src="'+prObj.api_url+'img/male-im.svg"><span class="gender_txt">男性</span>';
								}
								else if(items.cust_gender == "Female")
								{
									genderSign = '<img class="wk-gender-sign" src="'+prObj.api_url+'img/female-im.svg"><span class="gender_txt">女性</span>';
								}

								// === 2026.02.24 mitomiここから追加  ===
								// 数字と年代の対応表を作成（実際の選択肢に合わせて書き換えてください）
								var ageMapping = {
									"1": "20代",
									"2": "30代",
									"3": "40代",
									"4": "50代",
									"5": "60才以上"
								};

								var ageGroupSign = '';
								var ageVal = String(items.cust_age_group);

								// データが存在し、かつ空文字でも「-1(未選択)」でもない場合のみ処理
								if (ageVal && ageVal !== "" && ageVal !== "-1") {
									// 対応表に数字が存在すればそのテキストを、存在しなければ元の数字をそのまま表示する
									var ageText = ageMapping[ageVal] ? ageMapping[ageVal] : ageVal;
									
									ageGroupSign = '<span class="age_txt">' + ageText + '</span>';
								}
								
								html += '<p class="wk_customer_name">'/*+review_by+items.name*/+genderSign + ageGroupSign + '</p>';
								// === 2026.02.24 mitomiここまで修正 ===

								if(items.is_verified)
									html += '<p class="wk_verified_customer" >'+verified_customer+'</p>';
								else
									html += '<p class="wk_verified_customer" >&nbsp;</p>';
								html += '</div>';
								html += '</div>';
								html += '<h4 class="wk_rev_title wk-wrd-brk"><b>'+items.review_title+'</b></h4>';
								if(items.review_images){
									html += '<div class="wk_rev_img_wrp">';
									items.review_images.forEach(function(review_images,position){
										html += '<p class="wk_rev_img"><img src="'+review_images.review_image_url+'" ></p>';
									});
									html += '</div>';
								}
								html += '<p class="wk_rev_desc wk-wrd-brk">'+items.review_content+'</p>';
								html += '<p class="wk_rev_date">'+items.date_add.date.substring(0,10)+'</p>';
								html += '<hr>';
								prObj.$('.wk_all_reviews').append(html);
							}
						});
						if(data[0].img_url)
							prObj.$('#wk_prod_img').attr('src',data[0].img_url);
						else
							prObj.$('#wk_prod_img').attr('src',prObj.api_url+"img/No-Image/No-Image-140x140.png");
						prObj.$('.wk_prod_title').html(data[0].product_name);
						prObj.$('#wk_img_bg_tag').attr('href', window.location.origin+'/products/'+data[0].handle);
						prObj.$('#wk_product_btn_tag').attr('href', window.location.origin+'/products/'+data[0].handle);
						if(data.length >= limit && prObj.$(".wk-product-reviews").length == 0)
						{
							prObj.$('.wk_all_reviews').append('<a href="/pages/product-review/'+main_id_product+'"  style="color: #F13F3F;">'+view_all_review+'</a>');
						}
						else if(data.length >= limit  && prObj.$(".wk-product-reviews").length > 0){
							prObj.$('.wk_all_reviews').append('<a style="color: #F13F3F;cursor:pointer" id="load_more_rev" >'+load_more_reviews+'</a>');
						}
						else
						{
							prObj.$('.wk_all_reviews').append('<p>'+review_ends_here+'</p>')
						}
						data.forEach(function(items, index){
                            if(index <limit){
                                prObj.$('#wk_review_card_'+items.id).rateYo({
                                    starWidth:"18px",
                                    rating:items.review_star,
                                    spacing:"5px",
                                    multiColor:{
                                        startColor:"#000000",
                                        endColor:"#000000"
                                    },
                                    readOnly:!0,
                                    numStars:5
                                })
                            }
                        })
						if(prObj.$(".wk-product-reviews").length > 0)
						{
							prObj.$('.wk_prod_img_title').css('display','flex');
						}
						prObj.$('#load_more_rev').on('click', function(){
							prObj.$("#load_more_rev").remove();
							prObj.appendDiv(limit, page+1, sort_by, sort_order, is_verified, 1)
						})

					}
					if(prObj.$('.wk_no_review_yet').length > 0) prObj.$('.wk_no_review_yet').css({'display':no_review_status});
				},
				error: function(xhr, ajaxOptions, thrownError) {
					console.log(xhr.status);
					console.log(thrownError);
				},
				complete: function() {
					// prObj.removeLoader();
				}
			});

			prObj.$("<style type='text/css'> .btn-group, .btn-group-vertical {position: relative;display: inline-block; vertical-align: middle;}#stars { display:inline-flex;} .rateit ul > li.star.selected > i.fa {color:#FF912C;}#menuBarDiv a.btn {position: relative; margin-bottom: 3px;}.btn-default {color: #333;background-color: #fff;border-color: ccc;letter-spacing: 0.08em; padding: 6px 12px; border-radius: 4px; border-color: #ccc;} .Editor-editor {height: 150px; padding: 1%; border: 1px solid EEE; border-radius: 0; word-wrap: break-word;} .clicked{background-color: #e6e6e6;}.wk_rev_date{float:right;color:#777777}.wk_verified_customer{display:inline-block; color:#FF3535;margin-left:10px;}.wk_customer_name{color:#777777;float:left}</style>").appendTo("head");

			
		}
        prObj.appendDivByStar = function(limit, page, filter_star, is_verified = false, append_more = false){
			if(limit > 250){
				limit = 250;
			}
			var main_id_product = prObj.$("#wk-main-prod-id").val();
			var product_handle = prObj.product_handle;
			if(main_id_product == '' || typeof main_id_product == 'undefined' || prObj.$(".wk-product-reviews").length > 0)
			{
				main_id_product = prObj.product_handle;
			}
			prObj.$.ajax({
				url: prObj.api_url + 'index.php?p=ajax_product_review',
				async: true,
				cache: false,
				jsonpCallback: 'getfeedback',
				contentType: 'application/json',
				dataType: 'jsonp',
				data: {
					name: name,
					shop: prObj.shop_name,
					main_id_product: main_id_product,
					product_handle: product_handle,
					limit: limit,
					page: page,
					filter_star:filter_star,
					is_verified: is_verified
				},
				beforeSend: function() {
					// prObj.showLoader();
				},
				success: function(data) {
					let no_review_status = 'none';
					if (data == 'denied'){
						if(append_more == 1){
							prObj.$('.wk_all_reviews').append('<p >'+review_ends_here+'</p>')
						}
						else{
							no_review_status = 'block';
						}
					}
					else{
						data.forEach(function(items, index){
							if(index <limit)
							{
								html ='';
								html += '<div class="wk_review_card seller-product-review" data-id="'+items.id+'">';
								html += '<div class="wk_rev_hdr">';
								// html += '<p class="wk_rev_stars">'+prObj.getStars(items.review_star)+'</p>';
                                html += '<div class="wk_rev_stars"><div class="rateit" id="wk_review_card_'+items.id+'"></div></div>';
								html += '<div class="mp-full-width">';

                                genderSign = '';
								if(items.cust_gender == "Male")
								{
									genderSign = '<img class="wk-gender-sign" src="'+prObj.api_url+'img/male-im.svg"><span class="gender_txt">男性</span>';
								}
								else if(items.cust_gender == "Female")
								{
									genderSign = '<img class="wk-gender-sign" src="'+prObj.api_url+'img/female-im.svg"><span class="gender_txt">女性</span>';
								}
								html += '<p class="wk_customer_name">'/*+review_by+items.name*/+genderSign+'</p>';
                              
								if(items.is_verified)
									html += '<p class="wk_verified_customer" >'+verified_customer+'</p>';
								else
									html += '<p class="wk_verified_customer" >&nbsp;</p>';
								
								
								html += '</div>';
								html += '</div>';
								html += '<h4 class="wk_rev_title wk-wrd-brk"><b>'+items.review_title+'</b></h4>';
								// if(items.review_images){
								// 	items.review_images.forEach(function(review_images,position){
								// 		html += '<img src="'+review_images.review_image_url+'" style = "margin-right: 5%;" >';
								// 	});
								// }
								if(items.review_images){
									html += '<div class="wk_rev_img_wrp">';
									items.review_images.forEach(function(review_images,position){
										html += '<p class="wk_rev_img"><img src="'+review_images.review_image_url+'" ></p>';
									});
									html += '</div>';
								}
								
								html += '<p class="wk_rev_desc wk-wrd-brk">'+items.review_content+'</p>';
								html += '<p class="wk_rev_date">'+String(items.date_add.date).substring(0,10)+'</p>';
								html += '<hr>';
								prObj.$('.wk_all_reviews').append(html);
							}
						});
						if(data[0].img_url)
							prObj.$('#wk_prod_img').attr('src',data[0].img_url);
						else
							prObj.$('#wk_prod_img').attr('src',prObj.api_url+"img/No-Image/No-Image-140x140.png");
						prObj.$('.wk_prod_title').html(data[0].product_name);
						prObj.$('#wk_img_bg_tag').attr('href', window.location.origin+'/products/'+data[0].handle);
						prObj.$('#wk_product_btn_tag').attr('href', window.location.origin+'/products/'+data[0].handle);
						if(data.length >= limit && prObj.$(".wk-product-reviews").length == 0)
						{
							prObj.$('.wk_all_reviews').append('<a href="/pages/product-review/'+main_id_product+'"  style="color: #F13F3F;">'+view_all_review+'</a>');
						}
						else if(data.length >= limit  && prObj.$(".wk-product-reviews").length > 0){
							prObj.$('.wk_all_reviews').append('<a style="color: #F13F3F;cursor:pointer" id="load_more_rev_star" >'+load_more_reviews+'</a>');
						}
						else
						{
							prObj.$('.wk_all_reviews').append('<p>'+review_ends_here+'</p>')
						}
						data.forEach(function(items, index){
                            if(index <limit){
                                prObj.$('#wk_review_card_'+items.id).rateYo({
                                    starWidth:"18px",
                                    rating:items.review_star,
                                    spacing:"5px",
                                    multiColor:{
                                        startColor:"#000000",
                                        endColor:"#000000"
                                    },
                                    readOnly:!0,
                                    numStars:5
                                })
                            }
                        })
						if(prObj.$(".wk-product-reviews").length > 0)
						{
							prObj.$('.wk_prod_img_title').css('display','flex');
						}
						prObj.$('#load_more_rev_star').on('click', function(){
							prObj.$("#load_more_rev_star").remove();
							prObj.appendDivByStar(limit, page+1, filter_star, is_verified, 1)
						})

					}
					if(prObj.$('.wk_no_review_yet').length > 0) prObj.$('.wk_no_review_yet').css({'display':no_review_status});
				},
				error: function(xhr, ajaxOptions, thrownError) {
					console.log(xhr.status);
					console.log(thrownError);
				},
				complete: function() {
					// prObj.removeLoader();
				}
			});

			prObj.$("<style type='text/css'> .btn-group, .btn-group-vertical {position: relative;display: inline-block; vertical-align: middle;}#stars { display:inline-flex;} .rateit ul > li.star.selected > i.fa {color:#FF912C;}#menuBarDiv a.btn {position: relative; margin-bottom: 3px;}.btn-default {color: #333;background-color: #fff;border-color: ccc;letter-spacing: 0.08em; padding: 6px 12px; border-radius: 4px; border-color: #ccc;} .Editor-editor {height: 150px; padding: 1%; border: 1px solid EEE; border-radius: 0; word-wrap: break-word;} .clicked{background-color: #e6e6e6;}.wk_rev_date{float:right;color:#777777}.wk_verified_customer{display:inline-block; color:#FF3535;margin-left:10px;}.wk_customer_name{color:#777777;float:left}</style>").appendTo("head");
		}
		prObj.addCategoryReview = async function(val, cat_data = false){
			var main_id_product = prObj.$("#wk-main-prod-id").val();
			prObj.$.ajax({
				url: prObj.api_url + 'index.php?p=ajax_product_review',
				async: true,
				cache: false,
				jsonpCallback: 'addCategoryReview',
				contentType: 'application/json',
				dataType: 'jsonp',
				data: {
					shop: prObj.shop_name,
					main_id_product: main_id_product
				},
				beforeSend: function() {
					// prObj.showLoader();
				},
				success: function(data) {
					if (data == 'denied')
		            	console.log("No Review!!")
					else{
						data_val = Object.values(data);
						data_keys = Object.keys(data);
						var category_arr = [];
						if(data_val.length > 0)
						{
							prObj.$('.wk_all_type_rating').html('');
							prObj.$('.wk_all_type_rating_edit').html('');
							data_val.forEach(function(items, index){
								html = '';
								html += '<div class="side wk-mgn-top-10">';
								html += '<div class="wk-wrd-brk" style="width:30%">';
								html += '<p class="wk-mgn-top-10" style="font-size:16px;">'+items+' : </p>';
								html += '</div>';
								html +=	'<fieldset class="rating wk_mgn_lef_30" >';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_10" name="rating'+index+'" value="5" /><label for="wk_'+data_keys[index]+'_rat_10" title="5 stars"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_9" name="rating'+index+'" value="4.5" /><label class="half" for="wk_'+data_keys[index]+'_rat_9" title="4 1/2 stars"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_8" name="rating'+index+'" value="4" /><label for="wk_'+data_keys[index]+'_rat_8" title="4 stars"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_7" name="rating'+index+'" value="3.5" /><label class="half" for="wk_'+data_keys[index]+'_rat_7" title="3 1/2 stars"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_6" name="rating'+index+'" value="3" /><label for="wk_'+data_keys[index]+'_rat_6" title="3 stars"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_5" name="rating'+index+'" value="2.5" /><label class="half" for="wk_'+data_keys[index]+'_rat_5" title="2 1/2 stars"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_4" name="rating'+index+'" value="2" /><label for="wk_'+data_keys[index]+'_rat_4" title="2 stars"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_3" name="rating'+index+'" value="1.5" /><label class="half" for="wk_'+data_keys[index]+'_rat_3" title="1 1/2 stars"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_2" name="rating'+index+'" value="1" /><label for="wk_'+data_keys[index]+'_rat_2" title="1 star"></label>';
								html +=	'<input type="radio" id="wk_'+data_keys[index]+'_rat_1" name="rating'+index+'" value="0.5" /><label class="half" for="wk_'+data_keys[index]+'_rat_1" title="1/2 star"></label>';
								html +=	'</fieldset>';
								html += '</div>';
								if(val == 1)
								{
									prObj.$('.wk_all_type_rating').append(html);
									category_added = true;
								}
								else
								{
									prObj.$('.wk_all_type_rating_edit').append(html);
									edit_category_added = true;
								}
								// key_val = data_keys[index];
								category_arr.push({items});
							})
							prObj.$("fieldset label").click(function(){
								prObj.$(this).parent().find("label").css({"color": "#ddd"});
								prObj.$(this).css({"color": "#000000"});
								prObj.$(this).nextAll().css({"color": "#000000"});
								prObj.$(this).next().attr("checked",true);
								// console.log($(this).next())
							});
							prObj.category_arr = category_arr;
							if(val == 2 && typeof cat_data != 'undefined' && cat_data.length >0)
							{
								var rating = 0;
								cat_data.forEach(function(items, index)
								{
									rating = Math.round(items.avg_category * 2) / 2;
									prObj.$('body').find("input[id='wk_"+items.id+"_rat_"+rating*2+"']").attr("checked", true);
									prObj.$('body').find("input[id='wk_"+items.id+"_rat_"+rating*2+"']").parent().find("label").css({"color": "#ddd"});
									prObj.$('body').find("input[id='wk_"+items.id+"_rat_"+rating*2+"']").css({"color": "#FFD700"});
									prObj.$('body').find("input[id='wk_"+items.id+"_rat_"+rating*2+"']").nextAll().css({"color": "#FFD700"});
								})
							}
						}
					}
				},
				error: function(xhr, ajaxOptions, thrownError) {
					console.log(xhr.status);
					console.log(thrownError);
				},
				complete: function() {
					// prObj.removeLoader();
				}
			})
		}
		prObj.appendAverageFeedback = function()
		{
			var main_id_product = prObj.$("#wk-main-prod-id").val();
			var product_handle = false;
			if(main_id_product == '' || typeof main_id_product == 'undefined' || prObj.$(".wk-product-reviews").length > 0)
			{
				main_id_product = prObj.product_handle;
			}
			prObj.$.ajax({
				url: prObj.api_url + 'index.php?p=ajax_product_review',
				async: true,
				cache: false,
				jsonpCallback: 'getAverageFeedback',
				contentType: 'application/json',
				dataType: 'jsonp',
				data: {
					shop: prObj.shop_name,
					main_id_product: main_id_product
				},
				beforeSend: function() {
					// prObj.showLoader();
				},
				success: function(data) {
					if (data == 'denied'){
						// prObj.$('.wk_rate_product_div').append(prObj.getStars(0));
						// prObj.$('.wk_total_prpd_rev').append("Based on 0 Reviews");
						// prObj.$('#wk_product_review_overall').rateYo({
                        //     starWidth:"18px",
                        //     rating:0,
                        //     spacing:"5px",
                        //     multiColor:{
                        //         startColor:"#000000",
                        //         endColor:"#000000"
                        //     },
                        //     readOnly:!0,
                        //     numStars:5
                        // })
						// no_of_reviews = no_of_reviews.replace('#COUNT#', 0);
						// prObj.$('.wk_total_prpd_rev').append(no_of_reviews);
						prObj.$('.wk_product_rating').each(function (index) {
							prObj.$(this).find('.wk_rate_product_div').rateYo({
								starWidth: "18px",
								rating: 0,
								spacing: "5px",
								multiColor: {
									startColor: "#000000",
									endColor: "#000000"
								},
								readOnly: !0,
								numStars: 5
							});

							no_of_reviews = no_of_reviews.replace('#COUNT#', 0);
							prObj.$(this)
								.find('.wk_total_prpd_rev')
								.append(no_of_reviews);
						});
						prObj.$('.wk_filter_review').css("display","none");
					}
					else{
						var rat = prObj.getStars(data[0].average_rating);
						prObj.$('#wk_rate_by_5').html(data[0].average_rating.substring(0,3));
						// prObj.$('.wk_rate_product_div').append(rat);
						// prObj.$('#wk_product_review_overall').rateYo({
                        //     starWidth:"18px",
                        //     rating: data[0].average_rating,
                        //     spacing:"5px",
                        //     multiColor:{
                        //         startColor:"#000000",
                        //         endColor:"#000000"
                        //     },
                        //     readOnly:!0,
                        //     numStars:5
                        // })
						// no_of_reviews = no_of_reviews.replace('#COUNT#', data[0].total_count);
						// prObj.$('.wk_total_prpd_rev').append("Based on "+data[0].total_count+" Reviews");
						// prObj.$('.wk_total_prpd_rev').append(no_of_reviews);
						prObj.$('.wk_product_rating').each(function (index) {
							prObj.$(this).find('.wk_rate_product_div').rateYo({
								starWidth: "18px",
								rating: data[0].average_rating,
								spacing: "5px",
								multiColor: {
									startColor: "#000000",
									endColor: "#000000"
								},
								readOnly: true,
								numStars: 5
							});

							no_of_reviews = no_of_reviews.replace('#COUNT#', data[0].total_count);
							prObj.$(this)
								.find('.wk_total_prpd_rev')
								.append(no_of_reviews);
						});
						data.forEach(function(items, index){
							var fill_div = (items.rate_per_review/items.total_count)*100;
							prObj.$('#tot_bar_'+items.rating).html(items.rate_per_review);
							prObj.$('.wk-bar-'+items.rating).css("width",fill_div+"%");
						});
					}
				},
				error: function(xhr, ajaxOptions, thrownError) {
					console.log(xhr.status);
					console.log(thrownError);
				},
				complete: function() {
					// prObj.removeLoader();
				}
			});
		}
		prObj.appendAverageCategory = function(email)
		{
			var main_id_product = prObj.$("#wk-main-prod-id").val();
			var product_handle = false;
			if(main_id_product == '' || typeof main_id_product == 'undefined' || prObj.$(".wk-product-reviews").length > 0)
			{
				main_id_product = prObj.product_handle;
			}
			prObj.$.ajax({
				url: prObj.api_url + 'index.php?p=ajax_product_review',
				async: true,
				cache: false,
				jsonpCallback: 'appendAverageCategory',
				contentType: 'application/json',
				dataType: 'jsonp',
				data: {
					shop: prObj.shop_name,
					main_id_product: main_id_product,
					email: email
				},
				beforeSend: function() {
					// prObj.showLoader();
				},
				success: function(data) {
					prObj.$(".wk_rev_form").find("input[name='mvm_token']").val(data.token)
					if (data.param == 'denied'){
		            	console.log("No Review!!")
					}
					else{
						if(prObj.config_arr[131] == 1){
							data.param.forEach(function(items, index){
								degree = (items.avg_category/5)*360;
								html = '';
								if(degree > 180)
									html += '<div class="wk-cir wk-rad-75">';
								else
									html += '<div class="wk-cir">';
								html += '<span>'+items.avg_category.substring(0,3)+'</span>';
								html += '<div class="slice">';
								html += '<div class="bar" style="transform: rotate('+degree+'deg) "></div>';
								html += '<div class="fill"></div>';
								html += '</div>';
								html += '<p>'+items.category_name+'</p>';
								html += '</div>';
								prObj.$('.category-rating').append(html);
								
							});
							return data;
						}
					}
				},
				error: function(xhr, ajaxOptions, thrownError) {
					console.log(xhr.status);
					console.log(thrownError);
				},
				complete: function() {
					// prObj.removeLoader();
				}
			});
		}
		prObj.appendMyReview = function(email, sort_by = 'date_add', sort_order = 'desc'){
			prObj.$.ajax({
				url: prObj.api_url + 'index.php?p=ajax_product_review',
				async: true,
				cache: false,
				jsonpCallback: 'getMyReviews',
				contentType: 'application/json',
				dataType: 'jsonp',
				data: {
					shop: prObj.shop_name,
					email: email,
					sort_by: sort_by,
					sort_order: sort_order
				},
				beforeSend: function() {
					prObj.showLoader();
				},
				success: function(data) {
					if (data == 'denied')
					{
		            	console.log("No Review!!")
					}
					else{
						data.forEach(function(items, index){
							html ='';
							html += '<div class="wk_my_rev_div">';
							html += '<div class="disp_flx">';
							html += '<a href="'+window.location.origin+'/products/'+items.handle+'"><img src="';
							if(items.img_url)
								html += items.img_url;
							else
								html += prObj.api_url+"img/No-Image/No-Image-140x140.png";
							html += '" style="height:90px;width:90px;padding:4px"></a>';
							html += '<h4 class="wk-mgn-lft-5">'+items.product_name+'</h4>';
							html += '</div>';
							html += '<p class="wk-mgn-top-10">Reviews and Ratings</p>';
							html += '<p class="font-sz-16 wk_rev_title wk-wrd-brk">'+items.review_title+'</p>';
							if(items.review_images){
								items.review_images.forEach(function(review_images,position){
									console.log(review_images.id)
									html += '<img src="'+review_images.review_image_url+'" style = "margin-right: 5%;">';
								});
							}
							html += '<p class="wk_rev_stars">'+prObj.getStars(items.review_star)+'</p>';
							html += '<p class="wk_rev_desc wk-wrd-brk">'+items.review_content+'</p>';
							html += '<p >'+items.date_add.date.substring(0,10)+'</p>';
							html += '<button type="hidden" class="wk_edit_rev btn" value='+index+' >Edit</button>';
							html += '</div>';
							prObj.$('.wk_rev').append(html);
						});
						prObj.$(".wk_edit_rev").on('click',function(e){
							var id = prObj.$(this).val();
							form_data = data[id];
							rate_id = "rating"+form_data.review_star*2;
							prObj.$(".wk-modal").css("display","block");
							prObj.$('.wk_success_rev').css('display','none');
							var fromTop = prObj.$(window).scrollTop();
							if(fromTop > 100)
								prObj.$(".wk-modal-content").css('top', (fromTop - 100)+'px');
							modal_form = prObj.$(".mp-update-rev-form");
							modal_form.css("display","block");
							modal_form.find("input[name='id']").val(form_data.id);
							modal_form.find("input[name='email']").val(form_data.email);
							modal_form.find("textarea[name='review']").val(form_data.review_content);
							modal_form.find("input[name='title']").val(form_data.review_title);
							modal_form.find("input[name='main_id_product']").val(form_data.main_id_product);
							var is_prod_cat = prObj.config_arr[131];
							if(is_prod_cat == 1)
							{
								prObj.$('.wk_actual_rate').css('display','none');
								// if(!edit_category_added)
								// {
									if(typeof data[id].review_category != 'undefined' && data[id].review_category.length > 0){
										prObj.addCategoryReview(2, data[id].review_category);
									}
									else
										prObj.addCategoryReview(2);
								// }
								
							}
							else{
								modal_form.find("input[id='"+rate_id+"']").attr("checked", true);	
								$('#'+rate_id).parent().find("label").css({"color": "#ddd"});
								$('#'+rate_id).css({"color": "#FFD700"});
								$('#'+rate_id).nextAll().css({"color": "#FFD700"});
								$('#'+rate_id).next().attr("checked",true);
							}

						})
						prObj.$("#wk-close-contact").on('click',function(){
							prObj.$('#myModal').css('display','none');
						})
					}
				},
				error: function(xhr, ajaxOptions, thrownError) {
					console.log(xhr.status);
					console.log(thrownError);
				},
				complete: function() {
					prObj.removeLoader();
				}
			})
		}

		prObj.updateReview = function(form,cust_email){
			// prObj.$(".myModal").css("display","block")
			var ratings = [];
			var check = true;
			var rating = 0;
			if(typeof prObj.config_arr != 'undefined' && prObj.config_arr[131] == 0)
				rating = Number(form.find(':radio:checked').val());
			else if(prObj.category_arr.length > 0)
			{
				var avg_rate = 0;
				var count = prObj.category_arr.length;
				prObj.category_arr.forEach(function(items, index){
					rate = Number(form.find('input[name=rating'+index+']:radio:checked').val());
					avg_rate += rate;  
					if (typeof rate == 'undefined' || Number.isNaN(rate) || rate < 0.5) {
						form.find('.mp-err').html(empty_rating);
					}

					ratings.push(rate);
				});
				rating = avg_rate/count;
			}
			var review 			= form.find("textarea[name='review']").val().trim();
			var title 			= form.find("input[name='title']").val().trim();
			var main_id_product = form.find("input[name='main_id_product']").val().trim();
			var id 				= form.find("input[name='id']").val().trim();
			var script_reg 		= /(<([^>]+)>)/ig;

			var formData = new FormData();
			
			if (typeof rating == 'undefined' || Number.isNaN(rating) || rating < 0.5) {
				form.find('.mp-err').html(invalid_rating);
			} else if (title.length < 5) {
				form.find('.mp-err').html(invalid_summary);
			} else if (title.length > 160) {
				form.find('.mp-err').html(invalid_title);
			} else if (review.length < 5) {
				form.find('.mp-err').html(minimum_desc);
			} else if (review.length > 2000) {
				form.find('.mp-err').html(maximum_desc);
			}
			else if( script_reg.test(title) || script_reg.test(review) || script_reg.test(rating)){
				form.find('.mp-err').html('Html tags are not allowed');
			}
			else if(main_id_product != '')
			{
				review = encodeURIComponent(review);
				title = encodeURIComponent(title);

				formData.append("shop",prObj.shop_name);
				formData.append("email",cust_email);
				formData.append("title",title);
				formData.append("id",id);
				formData.append("rating",rating);
				formData.append("review",review);
				formData.append("main_id_product",main_id_product);
				formData.append("ratings",ratings);
				formData.append("callback", 'updateReview'); 

				prObj.$.ajax({
					url: prObj.api_url + 'index.php?p=ajax_product_review',
					//async: true,
					//cache: false,
					//jsonpCallback: 'updateReview',
					type: 'post',
					data: formData,
					contentType: false,
					processData : false,
					beforeSend: function() {
						
					},
					success: function(data) {
						console.log(data);
						if (data == 'script_error')
							form.find('.mp-err').html('Script tags are not allowed.. please try again after some time.');
						else if (data == 'sww')
							form.find('.mp-err').html('something went wrong.. please try again after some time.');
						else if (data == 'success') {
							console.log(data);
							form.slideUp(function() {
								prObj.$(this).hide();
								prObj.$('.wk_success_rev').css('display','block');
								// setTimeout(function(){prObj.$('body').find('.wk_success_rev').remove(); }, 1600);
								setTimeout(function(){prObj.$('.wk-modal').css("display","none"); }, 1000);
							});
						}
						else if(data == 'invalid_customer')
							form.find('.mp-err').html(invalid_customer);
						else if(data == 'already_reviwed')
							form.find('.mp-err').html(already_reviewed);
					},
					error: function(xhr, ajaxOptions, thrownError) {
						console.log(xhr.status);
						console.log(thrownError);
					},
					complete: function() {
						// location.reload(true);
					}
				});
                
                return false;
			}
		}
		prObj.submitFeedbackForm = function(form) {
			var ratings = [];
			var check = true;
			console.log(form);
			console.log(form.find('.ovr_all input:radio:checked').val());
			if(typeof prObj.config_arr != 'undefined' && prObj.config_arr[131] == 0){
				// var rating = Number(form.find('.ovr_all input:radio:checked').val());
                var rating = Number(form.find('#wk_rating_value').val());
			} else if(prObj.category_arr.length > 0)
			{
				var avg_rate = 0;
				var count = prObj.category_arr.length;
				var rating = 0;
				prObj.category_arr.forEach(function(items, index){
					rate = Number(form.find('input[name=rating'+index+']:radio:checked').val());
					avg_rate += rate;  
					if (typeof rate == 'undefined' || Number.isNaN(rate) || rate < 0.5) {
						form.find('.mp-err').html(empty_rating);
						check = false;
					}
					ratings.push(rate);
				});
				rating = avg_rate/count;
			}
			if(!check)
				return false
			var name = form.find("input[name='name']").val().trim();
			var email = form.find("input[name='email']").val().trim();
			var prod_name = form.find("input[name='prod_name']").val().trim();
			var review = form.find("textarea[name='review']").val().trim();
			var title = form.find("input[name='title']").val().trim();
			var email_reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
			var script_reg = /(<([^>]+)>)/ig;
			var main_id_product = prObj.$("#wk-main-prod-id").val();
			var mvm_token	= form.find("input[name='mvm_token']").val();
			
			 //var fileInput = document.getElementById('files').files;
			// console.log(fileInput);
			// var file = fileInput.files[0];
			// var formData = new FormData();
			// formData.append('file', file);

			var formData = new FormData();

			// Read selected files
			if(typeof prObj.config_arr != 'undefined' && prObj.config_arr[183] == 1)
			{
				var totalfiles = document.getElementById('files').files.length;
				console.log(totalfiles);
				for (var index = 0; index < totalfiles; index++) {
				   formData.append("files[]", document.getElementById('files').files[index]);
				}
			}

            if(typeof prObj.config_arr != 'undefined' && prObj.config_arr[284] == 1)
			{
				var cust_gender = form.find("select[name='cust_gender']").val();
				formData.append('cust_gender', cust_gender);
			}

			if(typeof prObj.config_arr != 'undefined' && prObj.config_arr[331] == 1)
			{
				var cust_age_group = form.find("select[name='cust_age_group']").val();
				formData.append('cust_age_group', cust_age_group);
			}

			if(main_id_product == '' || typeof main_id_product == 'undefined' || prObj.$(".wk-product-reviews").length > 0)
			{
				main_id_product = prObj.product_handle;
			}
			form.find('.mp-err').html('');
			form.siblings('.mp-success').hide();
			if (typeof rating == 'undefined' || Number.isNaN(rating) || rating < 0.5) {
				form.find('.mp-err').html(invalid_rating);
			} else if (name.length < 1) {
				form.find('.mp-err').html(invalid_name);
			} else if (!email_reg.test(email)) {
				form.find('.mp-err').html(invalid_email);
			} else if (title.length < 5) {
				form.find('.mp-err').html(invalid_summary);
			} else if (title.length > 160) {
				form.find('.mp-err').html(invalid_title);
			} else if (review.length < 5) {
				form.find('.mp-err').html(minimum_desc);
			} else if (review.length > 2000) {
				form.find('.mp-err').html(maximum_desc);
			}
			else if(script_reg.test(email) || script_reg.test(name) || script_reg.test(title) || script_reg.test(review)){
				form.find('.mp-err').html('Html tags are not allowed');
			}
			else {
				console.log(main_id_product);
				review = encodeURIComponent(review);
				title = encodeURIComponent(title);
				formData.append("mvm_token",mvm_token);
				formData.append("name",name);
				formData.append("shop",prObj.shop_name);
				formData.append("email",email);
				formData.append("title",title);
				formData.append("seller",prObj.seller);
				formData.append("rating",rating);
				formData.append("review",review);
				formData.append("main_id_product",main_id_product);
				formData.append("ratings",ratings);
				formData.append("product_name",prod_name);
				formData.append("callback", 'addReview'); 

				prObj.$.ajax({
					url: prObj.api_url + 'index.php?p=ajax_product_review',
					// async: true,
					// cache: false,
					// jsonpCallback: 'addReview',

					type: 'post',
					data: formData,
					contentType: false,
					processData : false,
					beforeSend: function() {
						prObj.showLoader();
					},
					success: function(data) {
						if (data == 'script_error')
							form.find('.mp-err').html('Script tags are not allowed.. please try again after some time.');
						else if (data == 'sww')
							form.find('.mp-err').html('something went wrong.. please try again after some time.');
						else if (data == 'success') {
							form.slideUp(function() {
								prObj.$(this).hide();
								prObj.$('.wk_success_rev').css('display','block');
								// setTimeout(function(){prObj.$('body').find('.wk_success_rev').remove(); }, 3000);
							});
						}
						else if(data == 'invalid_customer')
							form.find('.mp-err').html(invalid_customer);
						else if(data == 'already_reviwed')
							form.find('.mp-err').html(already_reviewed);
					},
					error: function(xhr, ajaxOptions, thrownError) {
						console.log(xhr.status);
						console.log(thrownError);
					},
					complete: function() {
						prObj.removeLoader();
					}
				});
                
                return false;
            }
        }
        prObj.getStars = function(rating) {
            // Round to nearest half
            rating = Math.round(rating * 2) / 2;
            let output = [];
            html = '';
            // Append all the filled whole stars
            for (var i = rating; i >= 1; i--) {
                html += '<i class="fa fa-star" aria-hidden="true" style="color: gold;"></i>&nbsp;';
            }

            // If there is a half a star, append it
            if (i == .5) {
                html += '<i class="fa fa-star-half-o" aria-hidden="true" style="color: gold;"></i>&nbsp;';
            }
            // Fill the empty stars
            for (let i = (5 - rating); i >= 1; i--) {
                html += '<i class="fa fa-star-o" aria-hidden="true" style="color: gold;"></i>&nbsp;';
            }

            return html;
        }
        prObj.removeLoader = function() {
            prObj.$('body').find('.mp-loader').hide();
        };
        prObj.loadCss = function(url) {
            var head = document.getElementsByTagName('head')[0], // reference to document.head for appending/ removing link nodes
                link = document.createElement('link'); // create the link node
            link.setAttribute('href', url);
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('type', 'text/css');

            head.appendChild(link); // insert the link node into the DOM and start loading the style sheet
            return link; // return the link node;
        }
        prObj.get_config = function() {
            var main_id_product = prObj.$('#wk-main-prod-id').val();
			var customer_email  = prObj.$('.wk_cust_email_rev').val();
            prObj.$.ajax({
                url: prObj.api_url + "index.php?p=ajax_get_config_front",
                type: 'POST',
                async: true,
                cache: false,
                data: {
                    'shop': prObj.shop_name,
                    'store': prObj.seller,
                    'ids': '131, 126, 183, 284, 331',
                    'todo': 'get_all_config',
                    'main_id_product': main_id_product,
					'customer_email': customer_email
                },
                success: function(data) {
                    console.log(data)
                    prObj.config_arr = data;
                    prObj.config_arr = JSON.parse(prObj.config_arr)
                    console.log(prObj.config_arr)
                    if(prObj.config_arr['valid_customer'] == "0" && prObj.$('.wk_post_div').length > 0){
						prObj.$('.wk_post_div').css({'display':'none'});
						if(prObj.$('.wk_no_review_yet').length > 0) prObj.$('.wk_no_review_yet').css({'display':'block'});
					}
                    return true;
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                }
            })
        }
		prObj.getProductReviewImage = function(currElem, currIndex = 0) {
			prObj.$('#wk-pageLoader').removeClass('hidden');
            let reviewId = currElem.attr('data-id');
            prObj.$.ajax({
                url: prObj.api_url + 'index.php?p=ajax_product_review',
                async: true,
                cache: false,
                dataType: 'jsonp',
                contentType: 'application/json',
                jsonpCallback: 'getSellerProductReviewImg',
                data: {
                    shop: prObj.shop_name,
                    product_review_id: reviewId
                },
                beforeSend: function() {
                },
                success: function(data) {
                    prObj.$('#wk-show-review-img-container').css('border', 'none');
                    if(prObj.slideInterval){
                        clearInterval(prObj.slideInterval);
                    }
                    if(data.length > 0){
                        prObj.$('#wk-show-review-img-container').css('border', '1px solid #ddd');
                        if(prObj.$('#wk-show-review-img-container .wk-swiper-wrapper')){
                            let slidesHtml = '';
                            data.forEach(d => {
                                slidesHtml += `<div class='wk-swiper-slide'><img src='${d.review_image_url}'/></div>`;
                            });
                            prObj.$('#wk-show-review-img-container .wk-swiper-wrapper').html(slidesHtml);
                        }
                        prObj.wkSlider('.wk-swiper', { autoplay: false, currentSlide: currIndex});
						console.log("model structred");
                    }
                    else{
                        prObj.$('#reviewImgModal').find('#wk-show-review-img-container').find('.wk-swiper-wrapper').html('<p>No Images found for this review</p>');
                    }
                    // if(prObj.$('#reviewImgModal').css('display') != 'block') {
                    //     prObj.$('#reviewImgModal').css({"display":"block"});
                    // }
					prObj.$('#wk-pageLoader').addClass('hidden');
					prObj.$('#reviewImgModal').addClass('show');
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                },
                complete: function () {
					prObj.$('#wk-pageLoader').addClass('hidden');
                }
            })
        }
		prObj.wkSlider = function(containerSelector, options = {}) {
            const container = document.querySelector(containerSelector);
            if (!container) return;
			console.log("slider module called")
            const slidesContainer = container.querySelector('.wk-swiper-wrapper');
            const slides = container.querySelectorAll('.wk-swiper-slide');

            const total = slides.length;
            let index = options.currentSlide ?? 0;
            let intervalId = null;

            const prevBtn = container.querySelector('.wk-swiper-button-prev');
            const nextBtn = container.querySelector('.wk-swiper-button-next');
            const pagination = container.querySelector('.wk-swiper-pagination');

			if(total === 1){
				prevBtn.style.display = 'none';
				nextBtn.style.display = 'none';
			}
			else{
				prevBtn.style.display = 'block';
				nextBtn.style.display = 'block';
			}

            if (pagination && pagination.children.length === 0) {
                // for (let i = 0; i < total; i++) {
                //     const dot = document.createElement('span');
                //     dot.dataset.index = i;
                //     if (i === 0) dot.classList.add('active');
                //     pagination.appendChild(dot);
                // }
                const page = document.createElement('span');
                page.innerHTML = `${index+1}/${total}`;
                pagination.appendChild(page);
            }

            function updateSlides() {
				slidesContainer.style.transition = 'transform 0.18s ease-out';
                slidesContainer.style.transform = `translateX(${-index * 100}%)`;
                if (pagination && pagination.querySelectorAll('span#dot').length > 0) {
                    const dots = pagination.querySelectorAll('span#dot');
                    dots.forEach(dot => dot.classList.remove('active'));
                    if (dots[index]) dots[index].classList.add('active');
                }
                else{
                    const page = pagination.querySelector('span');
                    page.innerHTML = `${index+1}/${total}`;
                }
            }

            function nextSlide() {
                index = (index + 1) % total;
                updateSlides();
            }

            function prevSlide() {
                index = (index - 1 + total) % total;
                updateSlides();
            }

            function goToSlide(i) {
                index = i;
                updateSlides();
            }

            if (nextBtn) nextBtn.addEventListener('click', nextSlide);
            if (prevBtn) prevBtn.addEventListener('click', prevSlide);
            if (pagination && pagination.querySelectorAll('span#dot').length > 0) {
                pagination.addEventListener('click', e => {
                    if (e.target.tagName === 'SPAN') {
                        goToSlide(parseInt(e.target.dataset.index));
                    }
                });
            }

            if (options.autoplay) {
                const delay = options.autoplayDelay || 3000;
                intervalId = setInterval(nextSlide, delay);
                container.addEventListener('mouseenter', () => clearInterval(intervalId));
                container.addEventListener('mouseleave', () => {
                    intervalId = setInterval(nextSlide, delay);
                });
            }

			let startX = 0;
			let endX = 0;
			let isDragging = false;
			container.addEventListener('touchstart', (e) => {
				startX = e.touches[0].clientX;
				isDragging = true;
			});
			container.addEventListener('touchmove', (e) => {
				if (!isDragging) return;
				endX = e.touches[0].clientX;
			});
			container.addEventListener('touchend', () => {
				if (!isDragging) return;
				const diff = startX - endX;
				if (Math.abs(diff) > 30) {
					if (diff > 0) {
						nextSlide();
					} else {
						prevSlide();
					}
				}
				startX = 0;
				endX = 0;
				isDragging = false;
			});
            updateSlides();
        }
        return prObj;
    })();
    prObj.path = window.location.pathname.split('/');
	prObj.shop_name = Shopify.shop;
	if(typeof verified_customer == 'undefined')
		verified_customer = "Verified Customer";
	if(typeof load_more_reviews == 'undefined')
		load_more_reviews = "Load More Reviews!";
	if(typeof review_ends_here == 'undefined')
		review_ends_here = "Reviews has been ended here!";
	if(typeof review_by == 'undefined')
		review_by = "By ";
	if(typeof no_of_reviews == 'undefined')
		no_of_reviews = "Based on #COUNT# Reviews.";
	if(typeof view_all_review == 'undefined')
		view_all_review = "View All Reviews.";
	if(typeof view_your_reviews == 'undefined')
		view_your_reviews = "View Your Reviews.";
	if(typeof invalid_token == 'undefined')
		invalid_token = 'Refreshing your page and try again';
	if(typeof invalid_name == 'undefined')
		invalid_name = 'Enter your name.';
	if(typeof invalid_email == 'undefined')
		invalid_email = 'Enter a invalid email address.';
	if(typeof invalid_summary == 'undefined')
		invalid_summary = 'Write some summary about review(minimum 5 characters)';
	if(typeof invalid_title == 'undefined')
		invalid_title = 'Review title should be less than 160 characters.';
	if(typeof minimum_desc == 'undefined')
		minimum_desc = 'Write some description about review(minimum 5 characters).';
	if(typeof maximum_desc == 'undefined')
		maximum_desc = 'Review description should be less than 2000 characters.';
	if(typeof invalid_customer == 'undefined')
		invalid_customer = 'Invalid Customer! , The customer needs to buy this product before giving the review.';
	if(typeof already_reviewed == 'undefined')
		already_reviewed = 'Your review has already been submitted before!.';
	if(typeof invalid_rating == 'undefined')
		invalid_rating = 'Please give some rating first.';
	if(typeof empty_rating == 'undefined')
		empty_rating = 'Rating can not be empty.';
	// if(prObj.$(".wk-product-reviews").length > 0){
	prObj.product_handle = prObj.path.pop(-1);
	prObj.page = prObj.path.pop(-2);
	prObj.api_url = 'https://sp-seller.webkul.com/';

	prObj.timediff = new Date().getTimezoneOffset(); 
	prObj.labels;
	prObj.seller_name;
	var arr=prObj.shop_name.split('.');
    prObj.domain_name = arr[0];
    prObj.category_arr = {};
    var category_added = false;
    // var edit_category_added = false;
    document.addEventListener('readystatechange', (event) => { console.log("documnet loading"); });

    if (prObj.page == 'products' || prObj.product_handle == 'product-review' || prObj.page == 'product-review' || prObj.product_handle == 'account') {
        prObj.loadjQuery(function() {
            prObj.get_config();
            if ((prObj.page == 'products' && prObj.$('#wk_reviews_section').length > 0) || (prObj.$(".wk-product-reviews").length > 0 && prObj.product_handle != 'my-review')) {
                prObj.$.ajaxSetup({
                    cache: false
                });
                if (prObj.page == 'products')
                    prObj.appendDiv(5, 1);
                else if (prObj.$(".wk-product-reviews").length > 0)
                    prObj.appendDiv(8, 1);
                prObj.appendAverageFeedback();
                prObj.appendAverageCategory();
                // prObj.checkLabels();

            }

            prObj.$('.mp-review-form').on('submit', function(e) {
                e.preventDefault();
                prObj.submitFeedbackForm(prObj.$(this));
            });

            prObj.$('.wk_post_rev').on('click', function(e) {
                e.preventDefault();
                var is_prod_cat = prObj.config_arr[131];
                var verify_customer_only = prObj.config_arr[126];
                var add_image_for_review = prObj.config_arr[183];
                var cust_select_gender   = prObj.config_arr[284];
				var cust_select_age_group = prObj.config_arr[331];
                if (add_image_for_review == 0) {
                    prObj.$('#wk_add_image_for_review').css('display', 'none');
                }
                if (is_prod_cat == 1) {
                    prObj.$('.ovr_all').css('display', 'none');
                    if (!category_added)
                        prObj.addCategoryReview(1);
                }
				if(prObj.$('#wk_all_type_initial_rating').data('rateYo')){
                    prObj.$('#wk_all_type_initial_rating').rateYo('destroy');
                    console.log("existing rateyo removed");
                }
                if(is_prod_cat == 0){
                    prObj.$('#wk_all_type_initial_rating').rateYo({
                        starWidth:"18px",
                        spacing:"5px",
                        multiColor:{
                            startColor:"#000000",
                            endColor:"#000000"
                        },
                        halfStar: true,
                        numStars:5
                    })
                    .on("rateyo.set", function (e, data) {
                        prObj.$('#wk_rating_value').val(data.rating);
                    });
                }
                if(cust_select_gender == 0) {
					prObj.$('#wk_select_gender').parent().parent().css('display', 'none');
				}
				if(cust_select_age_group == 0) {
					prObj.$('#wk_select_age_group_div').css('display', 'none');
				}
                wkform = prObj.$('.mp-review-form');
                var name = wkform.find("input[name='name']").val().trim();
                var email = wkform.find("input[name='email']").val().trim();
                if ((name != '' && email != '') || verify_customer_only == 0) {
                    prObj.$('.mp-review-form').css('display', 'block');
                    prObj.$(".wk_post_div").hide();
                    if (verify_customer_only == 0 && name == '' && email == '') {
                        prObj.$(".cust_lgn").css('display', 'block');
                        prObj.$(".mp-review-form input[name='name']").attr('type', 'text');
                        prObj.$(".mp-review-form input[name='email']").attr('type', 'text');
                    }
                } else {
                    var current_url = window.location.href
                    var redirect_url = encodeURIComponent(current_url)
                    var final_url = "/account/login?checkout_url=" + redirect_url
                    window.location.href = final_url;
                }
            });

            prObj.$('.wk_discard_form').on('click', function(e) {
                e.preventDefault();
                let form = prObj.$('.mp-review-form');
                form.slideUp(function() {
                    prObj.$(form).hide();
                    prObj.$(".wk_post_div").show();
                });
            })

            if (prObj.product_handle == 'account') {
                html = "<a href='/pages/product-review/my-review' class=' btn'>" + view_your_reviews + "</a>";
                prObj.$("#wk-your-reviews").append(html);
            }

            // if(prObj.$(".wk-product-reviews").length > 0 && prObj.product_handle != 'my-review')
            // {
            // 	prObj.appendDiv(5,1);
            // 	prObj.appendAverageFeedback();
            // 	prObj.appendAverageCategory();
            // }

            prObj.$("fieldset label").click(function() {
                prObj.$(this).parent().find("label").css({ "color": "#ddd" });
                prObj.$(this).css({ "color": "#000000" });
                prObj.$(this).nextAll().css({ "color": "#000000" });
                prObj.$(this).next().attr("checked", true);
                prObj.$(this).next().attr("checked", true);
            });

            if (prObj.product_handle == 'my-review') {
                prObj.$('#wk_reviews_section').css('display', 'none');
                prObj.$('.wk_my_review').css('display', 'block');
                var cust_email = prObj.$('.wk-product-reviews').data('cust');
                if (cust_email == '' || typeof cust_email == 'undefined' || !cust_email) {
                    prObj.$(".mp-loader").css("display", "block");
                    var current_url = window.location.href
                    var redirect_url = encodeURIComponent(current_url)
                    var final_url = "/account/login?checkout_url=" + redirect_url
                    window.location.href = final_url;
                    return false;
                } else {
                    prObj.appendMyReview(cust_email);
                }
                prObj.$('.mp-update-rev-form').on('submit', function(e) {
                    e.preventDefault();
                    prObj.updateReview(prObj.$(this), cust_email);
                });
                prObj.$('.wk_filter_review').css("display", "block");
                prObj.$('body').on('change', '#filter-myreview', function() {
                    filter = prObj.$(this).val();
                    var sort_order = '';
                    var sort_by = '';
                    if (filter == 1) {
                        sort_order = 'desc';
                        sort_by = 'date_add';
                    } else if (filter == 2) {
                        sort_order = 'asc';
                        sort_by = 'date_add';
                    } else if (filter == 3) {
                        sort_order = 'asc';
                        sort_by = 'review_star';
                    } else if (filter == 4) {
                        sort_order = 'desc';
                        sort_by = 'review_star';
                    }
                    prObj.$('.wk_rev').html('')
                    if (cust_email)
                        prObj.appendMyReview(cust_email, sort_by, sort_order)
                })
            } else {
                prObj.$('#wk_reviews_section').css('display', 'inline-block');
            }
            if (prObj.page == 'product-review') {
                prObj.$('.wk_review_nav').css('display', 'none');
                prObj.$('#wk_reviews_section').css('margin', '-10px 7%');
                prObj.$('#wk_comments').css('width', '50%');
                prObj.$('.wk_filter_review').css("display", "block");
                prObj.$('.wk_filter_review').css("display", "block");
				prObj.$('.bar-container').css('cursor', 'pointer');

                prObj.$('body').on('change', '#filter-review', function() {
                    filter = prObj.$(this).val();
                    var sort_order = '';
                    var sort_by = '';
                    if (filter == 1) {
                        sort_order = 'desc';
                        sort_by = 'date_add';
                    } else if (filter == 2) {
                        sort_order = 'asc';
                        sort_by = 'date_add';
                    } else if (filter == 3) {
                        sort_order = 'asc';
                        sort_by = 'review_star';
                    } else if (filter == 4) {
                        sort_order = 'desc';
                        sort_by = 'review_star';
                    }

                    prObj.$(".wk_all_reviews").html('');
                    if (filter != 5)
                        prObj.appendDiv(8, 1, sort_by, sort_order)
                    else
                        prObj.appendDiv(8, 1, sort_by, sort_order, 1)
                })
                prObj.$('body').on('click', '.bar-container', function() {
					var filterStar = prObj.$(this).data('star');
					prObj.$('#filter-star').val(filterStar);
					limit = 5;
					if(prObj.$('#filter-show-review')){
						limit = prObj.$('#filter-show-review').val();
					}

					filter = prObj.$("#filter-review").val();
					prObj.$(".wk_all_reviews").html('');
					if(filter != 5)
						prObj.appendDivByStar(limit, 1, filterStar)
					else
						prObj.appendDivByStar(limit, 1, filterStar, 1)
				})
				prObj.$('body').on('change', '#filter-show-review', function() {
					limit = prObj.$(this).val();
					filter = prObj.$("#filter-review").val();
					filterStar = prObj.$('#filter-star').val();
					prObj.$(".wk_all_reviews").html('');
					if(filter != 5)
						prObj.appendDivByStar(limit, 1, filterStar)
					else
						prObj.appendDivByStar(limit, 1, filterStar, 1)
				})
				prObj.$("body").on("click", ".seller-product-review .wk_rev_img img", function(e){
					let reviewCard = prObj.$(this).closest(".seller-product-review");
					let allImages = reviewCard.find(".wk_rev_img img");
					let clickIndex = allImages.index(this);
					console.log("current selelr product rveiew:: ", reviewCard);
					console.log("current index:: ", clickIndex);
					prObj.getProductReviewImage(reviewCard, clickIndex);
					console.log("called inside theme func")
                });
				var reviewImgModal = document.getElementById("reviewImgModal");
                prObj.$("body").on("click", ".wk-close-review-img", function(){
                    // reviewImgModal.style.display = "none";
					prObj.$(reviewImgModal).removeClass('show');
                });
				prObj.$("body").on("click", "#reviewImgModal", function(e){
                    if (prObj.$(e.target).is("#reviewImgModal")) {
						prObj.$(reviewImgModal).removeClass('show');
					}
                });

            }

            if(prObj.page == 'products') {
              	prObj.$('.bar-container').css('cursor', 'pointer');
              	prObj.$('body').on('click', '.bar-container', function() {
					var filterStar = prObj.$(this).data('star');
					prObj.$('#filter-star').val(filterStar);
					limit = 5;
					if(prObj.$('#filter-show-review')){
						limit = prObj.$('#filter-show-review').val();
					}

					filter = prObj.$("#filter-review").val();
					prObj.$(".wk_all_reviews").html('');
					if(filter != 5)
						prObj.appendDivByStar(limit, 1, filterStar)
					else
						prObj.appendDivByStar(limit, 1, filterStar, 1)
				})
				// prObj.$("body").on("click", ".seller-product-review", function(){
                //     prObj.$('#reviewImgModal').find('#slides').html('');
                //     prObj.getProductReviewImage(prObj.$(this));
				// 	console.log("called inside theme func")
                // });
				prObj.$("body").on("click", ".seller-product-review .wk_rev_img img", function(e){
					let reviewCard = prObj.$(this).closest(".seller-product-review");
					let allImages = reviewCard.find(".wk_rev_img img");
					let clickIndex = allImages.index(this);
					console.log("current selelr product rveiew:: ", reviewCard);
					console.log("current index:: ", clickIndex);
					prObj.getProductReviewImage(reviewCard, clickIndex);
					console.log("called inside theme func")
                });
				var reviewImgModal = document.getElementById("reviewImgModal");
                prObj.$("body").on("click", ".wk-close-review-img", function(){
                    // reviewImgModal.style.display = "none";
					prObj.$(reviewImgModal).removeClass('show');
                });
				prObj.$("body").on("click", "#reviewImgModal", function(e){
                    if (prObj.$(e.target).is("#reviewImgModal")) {
						prObj.$(reviewImgModal).removeClass('show');
					}
                });
            }


        });
    }

}).call(this);